import { Carousel, Typography } from "@material-tailwind/react";
import { useNavigate } from "react-router-dom";

const images = require.context("../../../uploads/Photos/Header-Photos/CarouselHome", false, /\.(webp|jpg|png|jpeg)$/);

const image_list = images.keys().map((imagePath) => images(imagePath).default || images(imagePath));

export default function CarouselHome() {
  const navigator = useNavigate();

  return (
    <Carousel
      autoplay={true}
      autoplayDelay={3500}
      loop={true}
      navigation={({ setActiveIndex, activeIndex, length }) => (
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-50">
          {new Array(length).fill("").map((_, i) => (
            <span
              key={i}
              className={`block h-1 cursor-pointer transition-all duration-300 rounded-md ${
                activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
              }`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      )}
    >
      {image_list.map((image_url, index) => (
        <div key={index} className="relative h-full w-full">
          <img
            src={image_url}
            alt={`Slide ${index + 1}`}
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 grid h-full w-full place-items-center bg-black/45 not-cursor-pointer" onClick={() => {
            window.scrollTo(0, 0);
            // navigator('/решенија-за-вашиот-дом')
          }
          } >
            <div className="w-3/4 text-center md:w-2/4">
              <Typography
                variant="h1"
                color="white"
                className="mb-4 text-sm md:text-xl lg:text-2xl text-start"
              >
                Решенија за вашиот дом
              </Typography>
            </div>
          </div>
        </div>
      ))}
    </Carousel>
  );
}
